import { useEffect, useRef, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";
import { locations } from "Helpers/Locations";

import UseServices from "Hooks/UseServices";

import Button from "Components/Global/Buttons";
// Variante Core direto, e não o `Components/Global/Form/Input`: o índice do Input
// carrega a variante de ARQUIVO, que puxa a cadeia UseNotification → SplashScreen
// → lottie-react e derruba qualquer suíte de teste em jsdom ("Cannot set
// properties of null (setting 'fillStyle')").
import { Core as TextInput } from "Components/Global/Form/Input/Variants/Core";
import Select from "Components/Global/Form/Select";

import * as S from "./styles";

// A chave gravada em realization_address é o NOME do estado ("São Paulo"), não a
// sigla — as opções precisam casar com o que está no banco.
const STATE_OPTIONS = locations.states.map((state) => ({
  value: state.name,
  label: state.name,
}));

// Digitar dispara requisição: sem espera, seria uma por tecla.
const TITLE_DEBOUNCE_MS = 400;

/**
 * Filtros da aba "Projetos Patrocinados" do patrocinador (a carteira de aportados).
 *
 * A filtragem é do backend (`POST /projects/list-active-projects`, chave
 * `filters`): os KPIs continuam sendo o retrato da carteira inteira e não
 * acompanham o filtro.
 */
const Filters = ({ filters, setFilters }) => {
  const { api } = UseServices();

  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [title, setTitle] = useState(filters?.title || "");

  const debounceRef = useRef(null);

  useEffect(() => {
    api
      .get("/projects/get-project-categories")
      .then((response) => {
        setCategoryOptions(
          (response.data || []).map((category) => ({
            value: category.id,
            label: category.display_name,
          })),
        );
      })
      .catch((error) => HTTPErrorCallback(error));
    // eslint-disable-next-line
  }, []);

  const apply = (next) => {
    setFilters((current) => ({ ...current, ...next }));
  };

  const onTitleChange = (event) => {
    const value = event.target.value;

    setTitle(value);

    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(
      () => apply({ title: value || null }),
      TITLE_DEBOUNCE_MS,
    );
  };

  const clear = () => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    setSelectedCategories([]);
    setSelectedState(null);
    setTitle("");
    setFilters({});
  };

  const hasFilter =
    !!title || !!selectedState?.value || selectedCategories.length > 0;

  return (
    <S.Wrapper>
      <Select
        name="filter_category_ids"
        label="Lei de incentivo"
        placeholder="Todas"
        options={categoryOptions}
        value={selectedCategories}
        isMulti
        onChange={(options) => {
          const selected = options || [];

          setSelectedCategories(selected);
          apply({
            category_ids: selected.length
              ? selected.map((option) => option.value)
              : null,
          });
        }}
      />

      <Select
        name="filter_territorio"
        label="Território"
        placeholder="Todos"
        options={STATE_OPTIONS}
        value={selectedState}
        onChange={(option) => {
          setSelectedState(option);
          apply({ territorio: option?.value || null });
        }}
      />

      <TextInput
        name="filter_title"
        label="Título"
        placeholder="Parte do nome do projeto"
        type="text"
        value={title}
        onChange={onTitleChange}
      />

      {hasFilter && (
        <S.Actions>
          <Button
            type="button"
            outline
            variant="tertiary"
            text="Limpar filtros"
            onClick={clear}
          />
        </S.Actions>
      )}
    </S.Wrapper>
  );
};

export default Filters;
